// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".waveform{--waveform-fill: #B4BCCD;--waveform-fill-shaded: #5645F5;height:100%;width:100%}.waveform .waves{fill:var(--waveform-fill);transition:fill 350ms ease}.waveform .waves.shaded{fill:var(--waveform-fill-shaded)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
